import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './HeaderGenericPrimary.css';
import React from 'react';
import { canUseDOM, get, getColorByTheme, getPageThemeColors } from '../../utils';
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';
import RouterLink from '../atoms/RouterLink';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
var videoWhiteOverlayTime = 750;
var videoFadeTime = 400;
var HeaderGenericPrimary = function HeaderGenericPrimary(_ref) {
  var rendering = _ref.rendering,
    fields = _ref.fields,
    children = _ref.children,
    params = _ref.params;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var variables = BackgroundColorHex ? {
    "--m57-header-generic-primary-background-color": BackgroundColorHex,
    "--m57-header-generic-primary-background-active-color": ActiveColorHex,
    "--m57-header-generic-primary-color": ColorHex
  } : {
    "--m57-header-generic-primary-background-color": selectedPrimaryColor,
    "--m57-header-generic-primary-background-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--m57-header-generic-primary-color": getColorByTheme(selectedPrimaryColor)
  };
  if (!fields) {
    console.warn('HeaderGenericPrimary component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [HeaderGenericLegislation component is empty: please provide data source]");
    }
    return null;
  }

  // 2 different sets of fields may come
  //
  var pageTitle = get(fields, 'pageTitle');
  var pageIntro = get(fields, 'pageIntro');
  var actualPageTitle = pageTitle && pageTitle.value ? pageTitle : get(fields, 'Title');
  var actualPageIntro = pageIntro && pageIntro.value ? pageIntro : get(fields, 'Intro Text');
  var hasTitle = Boolean(actualPageTitle.value);
  var hasIntroText = Boolean(actualPageIntro.value);
  //

  var ctaLink = get(fields, 'ctaLink.value.href');
  var ctaLabel = get(fields, 'ctaLabel.value');
  var mediaDesc = hasTitle ? actualPageTitle.value : hasIntroText ? actualPageIntro.value : '';
  var renderMediaPlaceholder = function renderMediaPlaceholder() {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "dot-media-header-primary",
      rendering: rendering,
      mediaDesc: mediaDesc
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "header header-generic--primary",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__media"
  }, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder()), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 header-content__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-content theme-contrast"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-animate__content-bg theme-contrast"
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-content__main header-animation__content"
  }, hasTitle && /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    className: "c-content__title",
    field: actualPageTitle
  }), hasIntroText && /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "c-content__text",
    field: actualPageIntro
  }), ctaLabel && ctaLink && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RouterLink, {
    href: ctaLink,
    className: "btn btn-secondary c-content__btn desktop__link",
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(params, {
        eventLab: ctaLabel
      }));
    },
    title: ctaLabel
  }, ctaLabel), /*#__PURE__*/React.createElement(RouterLink, {
    href: ctaLink,
    className: "btn btn-primary mob__link",
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(params, {
        eventLab: ctaLabel
      }));
    },
    title: ctaLabel
  }, ctaLabel))))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  })))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "header-animation ".concat(commonStyles, " ").concat(fullWidthStyles, " ").concat(rtl ? rtlStyles : ltrStyles, "  ").concat(headerImageStyle),
    removePaddingHeader: true,
    componentTabIndex: "disabled"
  }, children);
};
export var commonStyles = "c1tvdg7s";
export var ltrStyles = "l1jitq1y";
export var rtlStyles = "ruzjhmt";
export default HeaderGenericPrimary;